export const sortArrayByField = <T extends Record<string, any>>(
  array: T[],
  field: keyof T
): T[] => {
  return array.sort((a, b) => {
    const aStr = String(a[field]);
    const bStr = String(b[field]);
    const baseCompare = aStr.localeCompare(bStr, undefined, {
      sensitivity: 'base',
    });

    if (baseCompare === 0) {
      return bStr.localeCompare(aStr, undefined, { sensitivity: 'case' });
    }

    return baseCompare;
  });
};
